export const encodeURIComponentIfNeeded = (p) => {
  const encoded = encodeURIComponent(p);
  try {
    return decodeURIComponent(p) === p ? encoded : p;
  } catch {
    return encoded;
  }
};
